import { createContext, useContext } from 'react';

export type FormFieldComponent = React.ComponentType<{ fieldOptions: unknown }>;

export type FormFieldComponentResolver = (
    fieldType: string,
    fieldName: string
) => FormFieldComponent;

export const FieldComponentResolverContext = createContext<FormFieldComponentResolver | undefined>(
    undefined
);

export function useFormFieldComponentResolver(): FormFieldComponentResolver {
    const resolveFieldComponent = useContext(FieldComponentResolverContext);

    if (!resolveFieldComponent) {
        throw new Error('Missing FieldComponentRegistryProvider.');
    }

    return resolveFieldComponent;
}
